import { Box, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Typography } from '@mui/material';
import CustomPagination from '../../../components/forms/Pagination';

import { ConversionDto } from '../../../app/services/api/generated';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { TableHeader } from '../../../components/forms/TableHeader';
import { Pill } from '../../../components/shared/Pill';
import { TableLoading } from '../../../components/forms/TableLoading';
import { EmptyTable } from '../../../components/shared/EmptyTable';
import { EmptyRows } from '../../../components/forms/EmptyRows';

export const UomConversionsTable = (props: { page: number, maxPage: number, data: ConversionDto[], handlePageChange: (passedPage: number) => void, totalItems: number, isLoading: boolean, searchTerm: string, handleClearClick: () => void }) => {
  const { t } = useTranslation('uomConversions');

  useEffect(() => { }, [props.data]);

  const headerStyle = { whiteSpace: 'nowrap', py: 0 };

  if (props.totalItems == 0 && !props.isLoading) {
    return <EmptyTable bodyRowHeight={40}
      headerHeight={45}
      text={t('title')}
      searchTerm={props.searchTerm}
      onClear={props.handleClearClick}
      showOnAdd={false}
      onAdd={() => { }}
      onAddIsCreating={false}
      addItemText={t('create')}
      onAddIsDisabled={false} />;
  }

  return (
    <Box>
      <TableHeader>
        {t('conversions')}
        {(props.totalItems ?? 0) > 0 && <Pill text={`${props.totalItems} ${t('conversions')}`}></Pill>}
      </TableHeader>
      {props.isLoading ? <TableLoading headerHeight={45}
        bodyRowHeight={40}
        minTableWidth={900} /> :
        <TableContainer component={'div'}>
          <Table sx={{ minWidth: '900px' }}>
            <TableHead>
              <TableRow>
                <TableCell
                  sx={headerStyle}
                  align="left"
                >
                  {t('sku')}
                </TableCell>
                <TableCell
                  sx={headerStyle}
                  align="left"
                >
                  {t('itemName')}
                </TableCell>
                <TableCell
                  sx={headerStyle}
                  align="left"
                >
                  {t('fromUom')}
                </TableCell>
                <TableCell
                  sx={headerStyle}
                  align="left"
                >
                  {t('conversion')}
                </TableCell>
                <TableCell
                  sx={headerStyle}
                  align="left"
                >
                  {t('toUom')}
                </TableCell>
                <TableCell
                  sx={headerStyle}
                  align="left"
                >
                  {t('UomClass')}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {props.data.map((row) => (
                <TableRow
                  key={(row.itemId ?? '-') + '|' + (row.fromUom ?? '-') + '|' + (row.toUom ?? '-')}>
                  <TableCell>
                    {row.itemId}
                  </TableCell>
                  <TableCell variant='clampedText'>
                    <Typography variant='textXS'>
                      {row.itemDescription}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    {String(row.fromUom)}
                  </TableCell>
                  <TableCell>
                    {String(row.conversionNumber)}
                  </TableCell>
                  <TableCell>
                    {String(row.toUom)}
                  </TableCell>
                  <TableCell variant='clampedText'>
                    {String(row.toUomClass)}
                  </TableCell>
                </TableRow>
              ))}
              <EmptyRows numberOfCurrentRows={props.data.length}
                height={40} />
            </TableBody>
          </Table>
        </TableContainer>}
      <CustomPagination useNoDataMessage={false}
        page={props.page}
        setPage={props.handlePageChange}
        maxPages={props.maxPage}
        breakpointForChangeDisplay={120000}
      ></CustomPagination>
    </Box>
  );
};
